/** @odoo-module **/

import {Component, mount, xml, useState, useEffect, useRef, onWillStart} from "@odoo/owl";
//import { useService } from "@web/core/utils/hooks";

export class WPCPortalTeacherPortal extends Component {
    static template = 'wpc_portal.teacher_portal'
    static components = {
    }
    static defaultProps = {
    }
    setup() {
        var self = this;
    }
}
